import { doPost2, doGet2, API } from "./common"

const baseUrl = "/receiptVerification"



export const getSubmissionStatus = async (payload) => {
  
  let resp = await doGet2(`${baseUrl}/status`, payload)
  let data = await resp.json()
  return data;
}


//Request that the api send a reminder email to user later on.
export const requestEmailReminder = (breakId, stepId, receiptId, email, link) => {
  try {
    const payload = {
      breakId: breakId,
      stepId: stepId,
      receiptId: receiptId,
      email: email,
      link: link,
    }
  
    return doPost2(`${baseUrl}/schedule`, payload)
  } catch (e) {
    console.log(`Error in requestEmailReminder: ${e}`)
    return
  }
}

export const createAttachment = (breakId, stepId, receiptId, receiptSubmissionId, file) => {
  const data = new FormData()
  data.append("file", file)
  data.append("breakId", breakId)
  data.append("stepId", stepId)
  data.append("receiptId", receiptId)
  data.append("receiptSubmissionId", receiptSubmissionId)

  // TODO: need to make sure changes from BR-1963 (header auth) get merged into this
  // (this is the first instance of us using FormData)
  return fetch(`${process.env.DAILYBREAK_API_URL}/receiptVerification/upload`, {
    method: "POST",
    credentials: "include",
    body: data,
  }).then(response => {
    return response
  })
}

export const removeAttachment = (breakId, stepId, receiptId, receiptSubmissionId, receiptAttachmentId) => {
  
  let payload = {
    breakId: breakId,
    stepId: stepId,
    receiptId: receiptId,
    receiptSubmissionId: receiptSubmissionId,
    receiptAttachmentId: receiptAttachmentId,
  }
  
  return doPost2(`/receiptVerification/removeAttachment`, payload)

}

export const submitReceiptSubmission = (payload) => {

  return doPost2(`/receiptVerification/submit`, payload)
}

/* 
Usage:
    postFormWithProgress('/path', formData:FormData, handleProgress)
    .then((result) => {
        handleDone(true)
    }).catch((error) => {
        handleDone(false)
    })

returns a Promise

TODO: every other service method takes in params, whereas this takes in a FormData. 
Update this to be consistent with others? And move this method into common.js 
*/
export const postFormWithProgress = (path, formData, onProgress) => {
    
  return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.upload.addEventListener("progress", event => {
          console.log(`progress`, (event.loaded / event.total))
          if (event.lengthComputable) {
              onProgress && onProgress((event.loaded / event.total) * 100)
          }
      });

      // xhr.upload.addEventListener("load", event => {
      //     console.log(`load (done?)`, event)
      //     resolve(xhr.response);
      // });

      xhr.onreadystatechange = function() {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          const status = xhr.status;
          if (status === 0 || (status >= 200 && status < 400)) {
            resolve(xhr.response)
          } else {
            reject(xhr.response);
          }
        }
      }
      console.log(`begin`)
      xhr.open("POST", `${process.env.DAILYBREAK_API_URL}${path}`);
      // console.log(`token`, API.getToken())
      if (API.getToken()) {
        xhr.setRequestHeader("Authorization", `Token: ${API.getToken()}`)
      }
      xhr.withCredentials = true;
      xhr.send(formData);
  });
}
export class PostFormWithProgressClass {
    constructor(formData, onProgress, onError, onSuccess) {
      this.progress = 0
      this.path = '/receiptVerification/upload'
      this.error = null;
      this.success = false;
      this.formData = formData
      this.onProgress = onProgress
      this.onError = onError
      this.onSuccess = onSuccess
      this.start()
      return this
    }

    start() {
      this.onProgress && this.onProgress(this.progress)
      const xhr = new XMLHttpRequest();

      xhr.upload.addEventListener("progress", event => {
          console.log(`progress`, (event.loaded / event.total))
          if (event.lengthComputable) {
            this.progress = (event.loaded / event.total) * 100  
            this.onProgress && this.onProgress(this.progress)
          }
      });

    

      xhr.onreadystatechange = function() {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          const status = xhr.status;
          if (status === 0 || (status >= 200 && status < 400)) {
            this.success = true
            this.onSuccess && this.onSuccess(xhr.response)
          } else {
            this.error = xhr.response
            this.onError && this.onError(xhr.response)
          }
        }
      }
      console.log(`begin`)
      xhr.open("POST", `${process.env.DAILYBREAK_API_URL}${this.path}`);
      // console.log(`token`, API.getToken())
      if (API.getToken()) {
        xhr.setRequestHeader("Authorization", `Token: ${API.getToken()}`)
      }
      xhr.withCredentials = true;
      xhr.send(this.formData);

    }
  
     
  
}